(function() {
  var module;

  try {
    // Get current templates module
    module = angular.module('manager');
  } catch (error) {
    // Or create a new one
    module = angular.module('manager', []);
  }

  module.run(['$templateCache', function($templateCache) {
    return $templateCache.put('components/analytics/analytics.tpl.html', [
'<section class="analytics">',
'',
'  <date class="stats-conf" model="analytics.date" callback="analytics.load(analytics.role)"></date>',
'',
'  <select class="form-control stats-conf" ng-model="analytics.role" ng-change="analytics.setRole()"',
'    ng-options="role.cn as role.label for role in analytics.roles" chosen>',
'  </select>',
'',
'  <h3>',
'    <span translate>analytics.title</span>',
'    <span ng-if="analytics.role != \'all\'">',
'      <span translate>for</span>',
'      {{analytics.role}}',
'    </span>',
'  </h3>',
'',
'  <hr>',
'',
'  <div class="row">',
'    <stats',
'        data="analytics.requests"',
'        type="\'line\'"',
'        config="analytics.config.requests"',
'        title="\'analytics.requests\'"',
'        class="col-md-6"',
'        csv-config="analytics.requestsOptions"',
'    ></stats>',
'    <stats',
'        data="analytics.layers"',
'        type="\'bar\'"',
'        config="analytics.config.layers"',
'        title="\'analytics.layers\'"',
'        class="col-md-6"',
'        csv-config="analytics.usageOptions"',
'    ></stats>',
'  </div>',
'  <hr>',
'  <div class="row" ng-if="platformInfos.extractorappEnabled">',
'    <stats data="analytics.extractions" type="\'bar\'" config="analytics.config.extractions"',
'           title="\'analytics.extractions\'" class="col-md-4" csv-config="analytics.extractionOptions"/>',
'  </div>',
'',
'</section>',
'',''].join("\n"));
  }]);
})();